"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extensions = void 0;
var inline_modules_1 = require("./inline-modules/inline-modules");
var directives_1 = require("./utils/directives");
exports.extensions = {
    inlineModules: inline_modules_1.inlineModules,
    transformationPlugins: inline_modules_1.transformationPlugins,
    getMinimalCss: directives_1.removeStylableDirectiveRules
};
//# sourceMappingURL=extensions.js.map